import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Select from 'react-select';
import { getEJ2CalenderDateFormat } from "../../../Utils/index";
import { instance } from "../../../Actions/AxiosInstance";
import { DatePickerComponent } from '../../../Component/Custom';


export default class DeviceRawData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      to: '',
      from: '',
      selectedemployee: null,
    };

    this.onDownload = this.onDownload.bind(this);
    this.selectDate = this.selectDate.bind(this);
    this.convertDate = this.convertDate.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onCloseDrawer = this.onCloseDrawer.bind(this);
  }

  onDownload() {

  }

  convertDate(str) {
    const date = new Date(str);
    const mnth = (`0${date.getMonth() + 1}`).slice(-2);
    const day = (`0${date.getDate()}`).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  selectDate(a, args) {
    if (args.value) {
      const date = this.convertDate(args.value);
      this.setState({ [a]: date });
    } else {
      this.setState({ [a]: null });
    }
  }

  handleChange(name, type, selectedItem) {
    this.setState(
      {
        [name]: selectedItem.displayname,
        selectedemployee: selectedItem,
      },
    );
  }

  searchEmployee = (search) => {
    if (search.length < 3) return;
    if ((!this.state.prevSearch || this.state.prevSearch != search) && search.length >= 3) {
      const URL = `/subscription/employeelist`;
      const data = {
        searchfor: search,
        statusid: 1,
        featurekey: "biometric",
      };
        instance.post(URL, data).then((result) => {
            this.setState({ emplist: result.data.result });
        }).catch((error) => {
            this.props.enqueueSnackbar(error.response ? error.response.data.error.message : error.message, { variant: 'error' });
        });
    }
  };

  onCloseDrawer() {
    this.props.closeDrawer();
  }

  render() {
    return (
        <div>
          <div className='formwrapper'>
          <span className="drawer-cancle-btn">
            <svg onClick={this.onCloseDrawer} width="24" height="24" viewBox="0 0 24 24">
              <path d="M18.3 5.71c-.39-.39-1.02-.39-1.41 0L12 10.59 7.11 5.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z" />
            </svg>
          </span>
            <p className='title'>Device Raw Data</p>
            <div className="margin-bottom-16">
              <p className="form-input-label">
                Employee Name
              </p>
              <Select
                isMulti
                onInputChange={this.searchEmployee}
                onChange={(e) => this.handleChange("name", "text", e)}
                options={this.state.emplist}
                getOptionLabel={(option) => option.displayname}
                getOptionValue={(option) => option.displayvalue}
                value={this.state.selectedemployee}
                placeholder=""
                className="width77"
              />
            </div>
            <div className="margin-bottom-16" style={{ position: "relative", zIndex: 0 }}>
              <p className="form-input-label">
                Start Date
              </p>
              <DatePickerComponent
                placeholder="Start Date"
                format={getEJ2CalenderDateFormat()}
                id="dob"
                width='77%'
                start="Decade"
                change={(e) => this.selectDate("from", e)}
                value={new Date(this.state.from)}
                // onBlur={this.ValidateField.bind(this, "dob", "")}
              />
            </div>
            <div className="margin-bottom-16" style={{ position: "relative", zIndex: 0 }}>
              <p className="form-input-label" style={{ marginTop: 16 }}>
                End Date
              </p>
              <DatePickerComponent
                placeholder="End Date"
                format={getEJ2CalenderDateFormat()}
                id="dob"
                width='77%'
                start="Decade"
                style={{ marginBottom: 16 }}
                change={(e) => this.selectDate("to", e)}
                value={new Date(this.state.to)}
                // onBlur={this.ValidateField.bind(this, "dob", "")}
              />
            </div>
            <div>
              <Button
                className="mapbutton"
                onClick={this.onDownload}>
                  DOWNLOAD
              </Button>
            </div>
            <div className='note'>
              *This raw data si fetched in as-is form from our biometric attendance servers. If
              your biometric device has been online [+synced logs] with your biometric servers,
              all those logs are included in this raw data file.
            </div>
          </div>
        </div>
    );
  }
}
